import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import AuditHistoryPanel from "./index";

const PORTAL_ATTR = "data-audit-portal-root";
const HIDDEN_ATTR = "data-audit-hidden-by-portal";

const prepareAuditColumn = () => {
  const outer = document.querySelector(".enriched-tracking-view .ho-audit-outer");
  if (!outer) {
    return null;
  }

  const body = outer.querySelector(".ant-card-body");
  if (!body) {
    return null;
  }

  Array.from(body.children).forEach((child) => {
    if (child.getAttribute(PORTAL_ATTR) !== "true") {
      child.setAttribute(HIDDEN_ATTR, "true");
      child.style.display = "none";
    }
  });

  let root = body.querySelector(`[${PORTAL_ATTR}="true"]`);
  if (!root) {
    root = document.createElement("div");
    root.setAttribute(PORTAL_ATTR, "true");
    root.style.cssText =
      "display:flex;flex-direction:column;height:100%;overflow:hidden;flex:1";
    body.appendChild(root);
  }

  return root;
};

const AuditHistoryPortal = ({ auditInfo, showWhenEmpty }) => {
  const [container, setContainer] = useState(null);

  useEffect(() => {
    const attach = () => {
      const root = prepareAuditColumn();
      if (root) {
        setContainer(root);
        return true;
      }
      return false;
    };

    if (attach()) {
      return undefined;
    }

    const observer = new MutationObserver(() => {
      attach();
    });

    observer.observe(document.body, { childList: true, subtree: true });
    const intervalId = window.setInterval(() => {
      if (attach()) {
        window.clearInterval(intervalId);
        observer.disconnect();
      }
    }, 150);

    return () => {
      window.clearInterval(intervalId);
      observer.disconnect();
    };
  }, [auditInfo]);

  if (!container) {
    return null;
  }

  return createPortal(
    <AuditHistoryPanel auditInfo={auditInfo} showWhenEmpty={showWhenEmpty} inline />,
    container
  );
};

export default AuditHistoryPortal;
